/*
@file-overview 

- This service was brougth over from AEM wcax-commons repo

- This service contains methods using by coupon-list component

*/
/**
 * Coupon List Service 
 *
 */
import { Injectable } from "@angular/core";
import { CouponModel, ProductModel } from '../models/data.model';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UserInfoService } from "./user-info.service";
import { AemService } from "./aem.service";
import { CommonService } from "./common.service";
import { EnviormentConfig } from "../wcax-env-config";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";


@Injectable()

export class CouponListService {

    private _config = EnviormentConfig;
    private currentEnv = '';

    public constructor(
        private _http: HttpClient,
        private _userInfoService: UserInfoService,
        private _aemService: AemService,
        private _commonService: CommonService
    ) {
        this.currentEnv = this._commonService.getCurrentEnviorment();
    }

    /**
     * Get numbers of completed offers.
     *
     * @param {CouponModel[]} coupons
     * @param {ProductModel[]} product
     */
    public getTotalOffersCompleted(coupons: CouponModel[], product: ProductModel ): number {
        let count = 0;

        coupons.forEach(c => {
            if (c.status === 'C' && c.offerComplete == true || c.isClippable === false && c.offerComplete == true) {
                count++;
            }
        });
         
        if(product.offerComplete == true) {
            count++;
        }

        return count;
    }

    public getOffersByUpc(upc : string): Observable<any> {
        const storeId = this._userInfoService.getShopStoreId();
        const body = [upc];
        const httpHeaders = {
            "Content-Type": "application/json",
            "X-SWY-APPLICATION-TYPE": "web",
            "X-SWY_API_KEY": "emjou",
            "X-SWY_VERSION": "3.0"
        };    

        let offersByUpcUrl = this._config[this.currentEnv].baseURL.replace('{banner}', this._userInfoService.getBanner());
        offersByUpcUrl += this._config[this.currentEnv].offerDetailAPIDetails.offersByUpcPath + "?storeId=" + storeId + '&offerPgm=CC-PD';
        if (this._userInfoService.getSWY_SHOP_TOKEN()) {
            httpHeaders['Authorization'] = `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        const httpOptions = {
            headers: new HttpHeaders(httpHeaders)
        };
        return this._http.post(offersByUpcUrl,body, httpOptions).pipe(
            catchError((error) => {
                return throwError(new Error('Error in getting offers by upc'));
            })
        );
    }
}
